var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 647.06 969.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #dd4747;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.06,323.53c0,278.49-220.39,489.34-297.37,554.5-15.1,12.78-37.22,12.78-52.32,0C220.39,812.87,0,602.02,0,323.53,0,144.85,144.85,0,323.53,0s323.53,144.85,323.53,323.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 323.53,
    cy: 323.53,
    r: 207.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M532.7,895.63c0,40.77-93.64,73.82-209.16,73.82s-209.16-33.05-209.16-73.82c0-27.1,41.37-50.79,103.04-63.63,26.4,26.86,49.77,47.76,66.51,61.94,11.06,9.36,25.13,14.51,39.62,14.51s28.56-5.15,39.62-14.51c16.75-14.18,40.11-35.07,66.51-61.94,61.67,12.84,103.04,36.53,103.04,63.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/location-pin-icon.5082bbd0218f8f0d78b73d363a6bea0b.svg";
export { ForwardRef as ReactComponent };